/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiUpload } from "react-icons/fi";
import { COLOR_GRAY_TEXT, COLOR_PRIMARY } from "../../../constants/Colors";
import { GoFilePdf } from "react-icons/go";
import { MAX_FILE_SIZE } from "../../../constants/staticSelectItems";
import { errorToast } from "../../../services/toastService";

const getColor = (props) => {
  if (props.isDragAccept) {
    return "#00e676";
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isDragActive) {
    return "#2196f3";
  }
  return "#eeeeee";
};

const Container = styled.div`
  min-width: 260px;
  height: 200px;
  padding: 10px;
  border-width: 2px;
  border-radius: 20px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #ffffff;
  color: ${COLOR_GRAY_TEXT};
  outline: none;
  transition: border 0.24s ease-in-out;
  box-shadow: 0px 0px 5px #cccccc;
  align-content: center;
  p {
    text-align: left;
  }
`;

const DivImage = styled.div`
  width: 100%;
  cursor: pointer;
  border-radius: 20px;
  text-align: center;
  height: 200px;
`;

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  padding: 5px;
  object-fit: contain;
  object-position: center;
`;

const DropText = styled.div`
  margin: auto;
  text-align: center;
`;

const DropZone = ({
  uploadFile,
  removeFile,
  errors,
  placeholder = "Subir una image",
  image,
  readOnly = false,
  reset = false,
  errorMsg,
}) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept:
      "application/pdf, image/gif, image/jpeg, image/png, image/webp, image/tiff",
  });
  const [file, setFile] = useState(null);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (reset) {
        setFile(null);
        acceptedFiles.splice(file, 1);
      }
    }
  }, [reset]);

  useEffect(() => {
    if (acceptedFiles.length) {
      if (acceptedFiles?.[0]?.size > MAX_FILE_SIZE) {
        errorToast("Archivo mayor a 10MB");
        remove();
      } else {
        setFile(window.URL.createObjectURL(acceptedFiles[0]));
        uploadFile(acceptedFiles[0]);
      }
    }
  }, [acceptedFiles]);

  const remove = (file) => {
    setFile(null);
    acceptedFiles.splice(file, 1);
    removeFile();
  };
  const isPDF = file
    ? acceptedFiles?.[0]?.type === "application/pdf"
    : image?.toLowerCase().endsWith(".pdf");
  return (
    <section>
      {acceptedFiles.length || image ? (
        readOnly ? (
          <DivImage
            className="d-flex justify-content-center align-items-center shadow-4dp"
            style={{ cursor: readOnly ? "default" : "pointer" }}
          >
            {isPDF ? (
              <div
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(file || image, "_blank");
                }}
              >
                <GoFilePdf size={100} color={COLOR_PRIMARY} />
              </div>
            ) : (
              <ImagePreview src={file || image} alt="" srcset="" />
            )}
          </DivImage>
        ) : (
          <OverlayTrigger
            key="delete"
            overlay={<Tooltip id={`delete`}>Eliminar</Tooltip>}
          >
            <DivImage
              onClick={() => remove()}
              style={{ cursor: readOnly ? "default" : "pointer" }}
              className="d-flex justify-content-center align-items-center shadow-4dp"
            >
              {isPDF ? (
                <div>
                  <GoFilePdf size={100} color={COLOR_PRIMARY} />
                </div>
              ) : (
                <ImagePreview src={file || image} alt="" srcset="" />
              )}
            </DivImage>
          </OverlayTrigger>
        )
      ) : (
        <div>
          <Container
            {...getRootProps({
              style: { cursor: readOnly ? "default" : "pointer" },
              className: `dropzone shadow-2dp ${readOnly ? "readOnly" : ""}`,
            })}
          >
            {!readOnly && <input {...getInputProps()} />}
            <DropText>
              <FiUpload size={24} className="mr-2 text-primary" />
              <div>{placeholder}</div>
            </DropText>
          </Container>
          {errors && (
            <div className="mb-2 mt-0">
              <small className="text-danger">
                {errorMsg ? errorMsg : `${placeholder} es obligatorio.`}
              </small>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default DropZone;
